import React, {Component} from 'react';

import 'sass/modals/modalFaqBlock.scss';

class ModalFaqBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false
        };
    }

    render() {
        let {items} = this.props;

        let {show} = this.state;

        return (
            <div className="block-faq">
                <div className="top" onClick={() => this.setState({show: !this.state.show})}>
                    <div className="name">FAQ</div>
                    <div className={show ? 'icon-faq on' : 'icon-faq'} />
                </div>
                <div className={show ? 'text' : 'text hide'}>
                    {items.map && items.map((item, index) => <p key={index} className="item">{item}</p>)}
                </div>
            </div>
        )
    }
}

export default ModalFaqBlock;


// WEBPACK FOOTER //
// ./src/components/faq/ModalFaqBlock.js